import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=33de40fe&scoped=true&"
import script from "./Code.vue?vue&type=script&lang=ts&"
export * from "./Code.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33de40fe",
  null
  
)

export default component.exports